import moment from 'jalali-moment'

export const to_jalali = (date: string): string => {
  if (!date) return ''

  return moment(date, 'YYYY-MM-DD').locale('fa').format('YYYY-MM-DD')
}

export const to_jalali_year = (date: string): string => {
  if (!date) return ''

  return moment(date, 'YYYY-MM-DD').locale('fa').format('YYYY')
}

export const isLangEN = () => {
  const userLang = localStorage.getItem('i18nextLng') || 'en'
  if (userLang === 'en') {
    return true
  }
  return false
}

export const LocalizeDate = (date: string): string => {
  if (!date) return ''

  const isEnglish = isLangEN()
  const hasTime = date.includes(':')
  const inputFormat = hasTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
  const outputFormat = hasTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'

  if (isEnglish) {
    return moment(date, inputFormat).format(outputFormat)
  }

  return moment(date, inputFormat).locale('fa').format(outputFormat)
}
